import { getTelegramWebApp } from './telegram';

const stack: Array<() => void> = [];

export function pushBackButton(onClick: () => void) {
  const tg = getTelegramWebApp();
  if (!tg) return;
  if (stack.length > 0) tg.BackButton.offClick(stack[stack.length - 1]);
  stack.push(onClick);
  tg.BackButton.onClick(onClick);
  tg.BackButton.show();
}

export function popBackButton(onClick: () => void) {
  const tg = getTelegramWebApp();
  if (!tg) return;
  tg.BackButton.offClick(onClick);
  const idx = stack.lastIndexOf(onClick);
  if (idx !== -1) stack.splice(idx, 1);
  if (stack.length > 0) {
    const top = stack[stack.length - 1];
    tg.BackButton.onClick(top);
    tg.BackButton.show();
  } else {
    tg.BackButton.hide();
  }
}

export function showBackButton(onClick: () => void) {
  const tg = getTelegramWebApp();
  if (!tg) return;
  if (stack.length > 0) {
    tg.BackButton.offClick(stack[stack.length - 1]);
    stack[stack.length - 1] = onClick;
  } else {
    stack.push(onClick);
  }
  tg.BackButton.onClick(onClick);
  tg.BackButton.show();
}

export function hideBackButton() {
  const tg = getTelegramWebApp();
  if (!tg) return;
  if (stack.length > 0) tg.BackButton.offClick(stack[stack.length - 1]);
  stack.length = 0;
  tg.BackButton.hide();
}
